//  import Alpine from 'alpinejs';

// window.Alpine = Alpine;

export default {
  init() {
    // JavaScript to be fired on all pages
    // Alpine.start();

    // Flytta mobilmenyns overlay till <body> när den öppnas så att den inte
    // är inuti den vita header-pillens stacking context. Detta låter pillen
    // (inklusive "X"-close-knappen inom den) ligga synlig över overlayen.
    const overlay = document.querySelector<HTMLElement>(
      '.site-header .wp-block-navigation__responsive-container'
    );
    if (overlay) {
      const homePlaceholder = document.createComment('nav-overlay-home');
      overlay.parentElement?.insertBefore(homePlaceholder, overlay);

      const observer = new MutationObserver(() => {
        const isOpen = overlay.classList.contains('is-menu-open');
        if (isOpen && overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        } else if (!isOpen && overlay.parentElement === document.body) {
          homePlaceholder.parentElement?.insertBefore(overlay, homePlaceholder);
        }
      });
      observer.observe(overlay, { attributes: true, attributeFilter: ['class'] });

      // Låt hamburger/X-knappen agera som toggle: när menyn är öppen triggar vi
      // overlayens interna close-knapp (som är gömd men fortfarande funktionell).
      const openBtn = document.querySelector<HTMLElement>(
        '.site-header .wp-block-navigation__responsive-container-open'
      );
      if (openBtn) {
        openBtn.addEventListener('click', (e) => {
          if (overlay.classList.contains('is-menu-open')) {
            e.preventDefault();
            e.stopPropagation();
            const closeBtn = overlay.querySelector<HTMLElement>(
              '.wp-block-navigation__responsive-container-close'
            );
            closeBtn?.click();
          }
        }, true);
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
